import { useMemo } from "react";

export function LinkIcon({ className }: { className?: string }) {
  // Generate unique gradient ID for this instance
  const gradientId = useMemo(() => `link-gradient-${Math.random().toString(36).slice(2, 11)}`, []);
   
  return (
    <svg 
      className={className} 
      width="25" 
      height="25" 
      viewBox="0 0 25 25" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M13.516 12.6289L14.5336 13.6465C15.5347 14.6476 17.1579 14.6476 18.159 13.6465L21.7492 10.0563C22.7503 9.05519 22.7503 7.43207 21.7492 6.43096L18.1215 2.80332C17.1204 1.80221 15.4973 1.80221 14.4962 2.80332L10.906 6.39351C9.90489 7.39462 9.90489 9.01774 10.906 10.0189L11.9251 11.0379L11.4815 11.4814L10.4623 10.4622C9.4612 9.46111 7.83808 9.46111 6.83697 10.4622L3.25083 14.0484C2.24972 15.0495 2.24972 16.6726 3.25083 17.6737L6.8785 21.3014C7.87961 22.3025 9.50273 22.3025 10.5038 21.3014L14.09 17.7152C15.0911 16.7141 15.0911 15.091 14.09 14.0899L13.0725 13.0724L13.516 12.6289ZM16.5305 4.39431L20.1582 8.02195C20.2806 8.14438 20.2806 8.34288 20.1582 8.46531L16.568 12.0555C16.4456 12.1779 16.2471 12.1779 16.1246 12.0555L15.107 11.0379L16.0123 10.1327C16.4516 9.69331 16.4516 8.981 16.0123 8.54166C15.573 8.10232 14.8606 8.10232 14.4213 8.54166L13.516 9.44692L12.497 8.42786C12.3746 8.30543 12.3746 8.10693 12.497 7.9845L16.0872 4.39431C16.2096 4.27188 16.4081 4.27188 16.5305 4.39431ZM11.4815 14.6634L12.499 15.6809C12.6214 15.8033 12.6214 16.0018 12.499 16.1242L8.91285 19.7104C8.79042 19.8328 8.59192 19.8328 8.46949 19.7104L4.84182 16.0827C4.71939 15.9603 4.71939 15.7618 4.84182 15.6393L8.42796 12.0532C8.55039 11.9308 8.74889 11.9308 8.87132 12.0532L9.89054 13.0724L8.99636 13.9666C8.55702 14.4059 8.55702 15.1183 8.99636 15.5576C9.4357 15.9969 10.148 15.9969 10.5873 15.5576L11.4815 14.6634Z" 
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient 
          id={gradientId}
          x1="12.5" 
          y1="2.05249" 
          x2="12.5" 
          y2="22.0522" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE259"/>
          <stop offset="1" stopColor="#FFA751"/>
        </linearGradient>
      </defs>
    </svg>
  )
}